import SimpleAutocompleteFactory from "components/Autocomplete/SimpleAutocompleteFactory"
import { TransactionFilterTransactionMappingStatusValueEnum } from "services/api/openapi/models"

export const TransactionMappingsFilter = SimpleAutocompleteFactory<TransactionFilterTransactionMappingStatusValueEnum>({
  onlyManuallyMapped: "Manually mapped transactions",
  onlyAutoMapped: "Automatically mapped transactions",
})

export default TransactionMappingsFilter
